import '@grandvisionhq/utils';
import { getUnlocalizedSpecificationItem } from '../utils/get-unlocalized-specification-item.js';
import '@swc/helpers';
import '@grandvisionhq/graphql';
import '../../../types/product.js';
import { getSpecificationItems } from '../utils/get-specification-items.js';
import { mapServerToSpecificationsBase } from './map-server-to-specifications-base.js';
import { getSharedFrameSpecificationItems } from './shared/get-shared-frame-specification-items.js';

const mapServerToSunglassesSpecifications = (serverVariant, brand, prescriptionGlass)=>{
    const { segment , trend , lensFeatures , frameFeatures , roadworthiness , targetGender , targetGenderAllLocales ,  } = serverVariant.variantTypeDetails;
    const genderUnlocalized = getUnlocalizedSpecificationItem(targetGenderAllLocales);
    return [
        ...mapServerToSpecificationsBase(serverVariant, brand),
        ...getSpecificationItems({
            targetGender,
            genderUnlocalized,
            roadworthiness
        }),
        ...getSharedFrameSpecificationItems({
            segment,
            trend,
            lensFeatures,
            frameFeatures,
            prescriptionGlass
        }), 
    ];
};

export { mapServerToSunglassesSpecifications };
//# sourceMappingURL=map-server-to-sunglasses-specifications.js.map
